import { TooltipDialog } from '../../widgets'
import { useView } from '@10000/react'
import { isFree } from '../../../lookups'

export const YourDataDialogs = () => {
  const { subscription } = useView('tenant')
  const freeSquiz = isFree(subscription)

  return (
    <>
      {freeSquiz && <TooltipDialog
        order={0}
        title="Free Version"
        text="You’re currently using the free version. Some features are limited or unavailable."
        image="demo-notice"
        buttonText="Got it"
      />}
      <TooltipDialog
        order={1}
        title="Explore Your Graph"
        text="Click on any practice to see results, data and insights. Have fun!"
        image="wheel"
        buttonText="Explore"
      />
      <TooltipDialog
        order={3}
        title="Practice Overview"
        text={`Click "Learn more" to discover the two sub-practices for this practice, their related questions, and how your team answered those questions.`}
        image="practice"
        buttonText="Next"
      />
      <TooltipDialog
        order={5}
        title="Ready to Improve?"
        text="When you have fully explored your results, click this red button to find some tips and hints about how to improve at this practice."
        image="improve"
        buttonText="Next"
      />
      {!freeSquiz && <TooltipDialog
        order={7}
        title="Your Squiz History"
        text="The circles below indicate your past Squizzes, you can click on any of them to review past data."
        image="history"
        buttonText="Next"
      />}
      <TooltipDialog
        order={9}
        title="Compare Your Results"
        text={freeSquiz
          ? `Here you can compare your results with our global database.`
          : `Here you can choose to compare your results with our global database or your Consensus responses.`}
        image="compare"
        buttonText="Explore"
      />
    </>
  )
}